import styled from 'styled-components';
const DropdownMenuDivider = styled.hr.withConfig({
  displayName: "DropdownMenuDivider",
  componentId: "sc-18d4do7-0"
})(["height:1px;border:none;background-color:var(--neutral-border);margin:var(--size-spacing-02) 0;"]);
DropdownMenuDivider.displayName = 'DropdownMenu.Divider';
export default DropdownMenuDivider;